import { taskRequiresEvidence, type TaskTemplate } from '@jms/model';
import { evidenceLevelsSummary } from '@jms/ui/ui.evidence.enforcement.control';
import type { EntityBoardListPropertyPresentation, EntityBoardListPropertyResolver, EntityBoardListTitleAdornmentResolver } from '@workbuddy/ui/v2/blocks/entity.board/context';

// Task Template list projections registered by the manifest: evidence chip and mandatory / disabled tone.

/**
 * A template declares evidence, it never captures it — so unlike the Task chip there is no
 * captured / pending state to show, only whether the row asks for evidence at all.
 */
export const resolveTaskTemplateEvidenceListProperty: EntityBoardListPropertyResolver = ({ item }): EntityBoardListPropertyPresentation | null => {

  const template = item as TaskTemplate;
  if (!taskRequiresEvidence(template)) return null;

  return {
    label: 'Evidence',
    // Each collection names its own level, so the prefix must not claim the task is blocked when every level is Optional.
    tooltip: `Evidence: ${evidenceLevelsSummary(template)}`,
    iconLeft: 'fa-regular fa-clipboard-check',
    tone: 'muted',
    dashed: true,
    disabled: template.disabled === true,
  };
};

/** Mandatory asterisk, and the disabled tone legacy paints on the whole row (`task.node.general.component.html:1`). */
export const resolveTaskTemplateTitleAdornment: EntityBoardListTitleAdornmentResolver = (item) => {

  const template = item as TaskTemplate;
  if (template.disabled === true) return { icon: 'fa-regular fa-ban', label: 'Disabled', tone: 'neutral' };
  if (template.mandatory !== true && template.mandatoryForClaiming !== true) return null;
  return { icon: 'fa-solid fa-asterisk', label: 'Mandatory', tone: 'error' };
};
